import React from 'react';

import { Select } from 'antd';

import styled from 'styled-components';

import FilterClearButton from '@components/Gui/NwForm/FilterClearButton';

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 1rem;

    .ant-select {
        width: 80px;
    }

    /* "between [min] and [max]" non sta su una riga sola su schermi stretti:
       i due select si dividono lo spazio residuo invece di sfondare */
    @media (max-width: ${(props) => props.theme.NarrowScreenMaxWidth}) {
        flex-wrap: wrap;
        gap: 0.5rem;

        .ant-select {
            flex: 1 1 4rem;
            width: auto;
        }
    }
`;

const AgeSelector = ({ onChange, onBlur, value, disabled }) => {
    const MinValue = value ? value[0] : null;
    const MaxValue = value ? value[1] : null;

    const onMinValueChange = (val) => {
        onChange([val, value[1]]);
    };

    const onMaxValueChange = (val) => {
        onChange([value[0], val]);
    };

    const handleReset = () => {
        onChange([null, null]);
    };

    // Generate options from 0 to 120
    const options = [
        { value: null, label: 'Any' },
        ...Array.from({ length: 121 }, (_, i) => ({
            value: i,
            label: i.toString(),
        })),
    ];

    return (
        <Wrapper>
            <span>between</span>
            <Select
                disabled={disabled}
                value={MinValue}
                onChange={onMinValueChange}
                options={options}
            />
            <span>and</span>
            <Select
                disabled={disabled}
                value={MaxValue}
                onChange={onMaxValueChange}
                options={options}
            />
            <FilterClearButton onClick={handleReset} />
        </Wrapper>
    );
};

export default AgeSelector;
